import _bundle from "../../core/core--bundles";

let _sectionName = '';
const _sendOnPost = $('#sendOnPost').val() === 'True';

const runSetup = () => {
    let $attachmentWrapper = $('.js-multi-attachment-card'),
        $attachmentInput = $attachmentWrapper.find('input[type=file]'),
        $attachmentDelete = $attachmentWrapper.find('.l-delete');

    if ($attachmentWrapper.length) {
        $.each($attachmentInput, function (index, ele) {
            const k_upload = $(ele).data('kendoUpload');
            if (k_upload && !_sendOnPost) {
                onUpload(k_upload);
                onComplete(k_upload);
            }

            if (_sendOnPost) {
                clearAttachmentEvent(k_upload.wrapper);
                validationEvents(k_upload);
                k_upload.wrapper.addClass('k-hide-actions');
            }
        });

        if ($attachmentDelete.length) {
            if(!_sendOnPost) removeAttachmentEvent($attachmentDelete);
        }
        removeAttachment($('[name=canAdd]'));

        _sectionName = $('[name=sectionName]').val();
    }
}

export default function () {
    runSetup();

    _bundle.add({
        name: 'Rerun Attachment Events',
        event: ['on:AttachmentLoad'],
        fn() {
            runSetup();
        }
    });
}

const validationEvents = k_upload => {
    k_upload._events.select = k_upload._events.select || [];
    k_upload._events.select.push(function(e) {
        for (let i in e.files) {
            const file = e.files[i];
            const error = !!file.validationErrors?.length ? file.validationErrors[0] : undefined;

            if (error) {
                const errorMessageString = e.sender.localization[error];
                updateFileUiOnError(file, undefined, file, errorMessageString);
            }
        }
    });
};

const removeAttachment = ($canAdd) => {
    $.each($canAdd, function (index, ele) {
        let $self = $(ele),
            $parent = $self.parent();

        if ($self.val() !== 'True') {
            //Remove Attachment things
            $parent.find('[class^=dropZoneElement]').parent().remove();
            $parent.find('.k-dropzone').remove();
            $parent.find('.k-upload-button').remove();
            $parent.find('.k-button.l-delete').remove();
        }
    });
};

const onUpload = (k_upload) => {
    k_upload._events.upload = k_upload._events.upload || [];
    k_upload._events.upload.push(function (e) {
        let $self = $(this.element),
            $group = $self.parents('.js-attachment-group'),
            sectionName = $group.find('[name=sectionName]').val();
        if (sectionName === 'ProjectPage') {
            let $catSelect = $('#AttachmentCategory');
            if ($catSelect.length) {
                let k_catSelect = $catSelect.data('kendoDropDownList');
                if (k_catSelect) {
                    sectionName = k_catSelect.value();
                }
            }
        }
        e.data = {
            Id: parseInt($self.data('id')), Section: sectionName, AttachmentList: e.files
        };
    });
};

const clearAttachment = (e) => {
    const ele = $(e.currentTarget);
    const upload = ele.parents().find('div.js-multi-attachment-card').find('input[type=file]').data('kendoUpload')
    const attId = ele.data('uid-remove');
    upload.clearFileByUid(attId);
};

const clearAttachmentEvent = ($wrapper) => {
    $wrapper.on('click', '.k-button.l-delete', clearAttachment);
};

const removeAttachmentEvent = ($attachmentDelete) => {
    $attachmentDelete.click(function (event) {
        const ele = event.currentTarget;
        const attId = ele.getAttribute('data-file-id');
        const uid = ele.getAttribute('data-uid-remove');

        const $files = $(ele)
            .parents('.js-multi-attachment-card')
            .find('[id^=files]');

        const kendoUploadEle = $files.data('kendoUpload');

        if (!attId || attId === 'undefined' || attId === -1) {
            kendoUploadEle.clearFile(function(file) {
                if (!file) return false;
                return file[0].uid === uid;
            });

            return;
        }

        $.ajax({
            //potential to use same controller
            type: 'POST',
            url: '/Attachment/RemoveAttachment',
            data: 'attID=' + attId,
            success: function (attId, response) {
                if (response === 'success') {
                    kendoUploadEle.clearFile(function (file) {
                        if (!file) return false;
                        return file[0].uid === uid;
                    });
                }
            }
        });
    });
};

const updateFileUiOnError = function(loc, attId, file, error) {
    const ttl = $('.k-file-name[data-uid="' + loc.uid + '"]');
    ttl.attr('title', file.name);
    ttl.html(file.name);

    setTimeout(() => {
        const li = $('.k-file[data-uid="' + loc.uid + '"]');
        li.addClass('k-file-error');
        li.removeClass('k-file-success');

        const validationMessageElement = li.find('.k-file-validation-message');
        validationMessageElement.html(error);
        validationMessageElement.removeClass('k-text-success');
        validationMessageElement.addClass('k-text-error');

        li.find('.k-file-size').hide();
    });
};

const updateFileUiOnSuccess = function(loc, attId, file) {
    const dla = $('[data-uid-download="' + loc.uid + '"]');
    dla.attr('href', '/Download/Attachment?attid=' + attId);

    const ra = $('[data-uid-remove="' + loc.uid + '"]');
    ra.attr('data-file-id', attId);

    const ttl = $('.k-file-name[data-uid="' + loc.uid + '"]');
    ttl.attr('title', file.name);
    ttl.html(file.name);
};

const processEachFileOnUploadSuccess = function(file, uIndex, locFiles, resp) {
    const attId = resp.Data[uIndex].Id;
    const error = resp.Data[uIndex].Error;

    locFiles.forEach(function(loc) {
        if (loc.name === file.name && loc.uid === file.uid) {
            if (error) {
                updateFileUiOnError(loc, attId, file, error);
                return;
            }

            updateFileUiOnSuccess(loc, attId, file);
        }
    });
};

const processUploadResult = function(k_upload, e) {
    const locFiles = k_upload.getFiles();
    const resp = JSON.parse(e.XMLHttpRequest.response);

    e.files.forEach(function(file, uIndex) {
        processEachFileOnUploadSuccess(file, uIndex, locFiles, resp);
        removeAttachmentEvent($(`.l-delete[data-uid-remove=${file.uid}]`));
    });

    k_upload._showHeaderUploadStatus(false);
};

const processUploadResultProjectPage = function(k_upload) {
    k_upload._showHeaderUploadStatus(false);

    $('.js-attachment-grid')
        .data('kendoGrid')
        .dataSource.read();

    $('.k-file').remove();
};

const onComplete = function(k_upload) {
    k_upload._events.success = k_upload._events.success || [];

    k_upload._events.success.push(function(e) {
        if (e.operation !== 'upload') {
            return true;
        }

        if (_sectionName === 'ProjectPage') {
            processUploadResultProjectPage(k_upload);
            return true;
        }

        processUploadResult(k_upload, e);

        return true;
    });
};
